import { FaxDirectorySearchResultItem } from "@/ContactDirectory/Components/Search/FaxDirectorySearchResultItem";
import { DirectorySelectableEntity } from "@/ContactDirectory/Models/DirectorySelectableEntity";
import { IDirectoryEntity } from "@/ContactDirectory/Models/IDirectoryEntity";
import { DirectoryEntityMapper } from "./DirectoryEntityMapper";

export class FaxDirectorySearchResultItemMapper {
    public static toDirectorySelectableEntity(item: FaxDirectorySearchResultItem): DirectorySelectableEntity<IDirectoryEntity> {
        if (!item)
            return;

        return DirectoryEntityMapper.toDirectorySelectableEntity(item.entity) ?? item.preferredPharmacy?.toDirectorySelectableEntity();
    }
}
